module.exports = __webpack_public_path__ + "static/img/gzjrfz-logo.30a290b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login/gzjrfz-logo.png
// module id = YjdK
// module chunks = 3